// Container
import withCheckboxTable from './withCheckBoxTable';
export default withCheckboxTable;